module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0081.jpg?v=98236ff6";